import * as XLSX from "xlsx";
import { Logger } from "@base-provider";

export const convertFile = ({ files, hasHeaders = true }) => {
  Logger.of("App.Core.FileUploader.convertFile").info({ files });
  return new Promise((resolve, reject) => {
    if (files.length > 0) {
      var reader = new FileReader();
      reader.readAsArrayBuffer(files[0]);
      reader.onload = function (e) {
        var data = new Uint8Array(reader.result);
        var workbook = XLSX.read(data, { type: "array", sheetRows: 11 });
        var sheet = workbook.Sheets[workbook.SheetNames[0]];
        var json;
        if (hasHeaders) {
          json = XLSX.utils.sheet_to_json(sheet, {defval:""});
        } else {
          json = XLSX.utils.sheet_to_json(sheet, {
            defval:"",
            header: [...Array(1000).keys()].map((i) => `Column ${i}`),
          });
        }

        Logger.of("App.Core.FileUploader.convertFile.onload").info({
          json,
        });
        resolve({ data: json, file: files[0] });
      };
    } else {
      resolve([]);
    }
  });
};

/*
  id,firstname,lastname,email,profession,office
  85105cdc-280f-46bd-9e2a-a8d1e188f216,Farrah,Grosz,Farrah.Grosz@yopmail.com,worker,Niue
  5c9c0372-6fcd-496c-bfb5-7d68d227ca88,Cecile,Lynn,Cecile.Lynn@yopmail.com,doctor,Mozambique
  7a2fddb2-a574-49b9-a605-9ea46d05915d,Drucie,Zitvaa,Drucie.Zitvaa@yopmail.com,worker,Svalbard and Jan Mayen
  65801724-ee77-4e03-b6b1-6338f61d1fab,Tami,Cynar,Tami.Cynar@yopmail.com,firefighter,Oman
  1c29d25a-4743-4895-9e9d-0d9e939d5ee7,Christal,Calhoun,Christal.Calhoun@yopmail.com,doctor,Madagascar
  f6618f5d-4728-4ca6-b30d-3db6a674fca0,Noelle,Ventre,Noelle.Ventre@yopmail.com,firefighter,Macao
  01e6346c-02c9-479b-b830-0ac259f431b1,Regina,Hashim,Regina.Hashim@yopmail.com,worker,Malaysia
  
  id	firstname	lastname	email	profession	office
  85105cdc-280f-46bd-9e2a-a8d1e188f216	Farrah	Grosz	Farrah.Grosz@yopmail.com	worker	Niue
  5c9c0372-6fcd-496c-bfb5-7d68d227ca88	Cecile	Lynn	Cecile.Lynn@yopmail.com	doctor	Mozambique
  */
export const convertText = ({ text, hasHeaders = true, delimeter = "," }) => {
  Logger.of("App.Core.FileUploader.convertText").info({ text });
  return new Promise((resolve, _reject) => {
    var workbook = XLSX.read(text, {
      type: "string",
      sheetRows: 11,
      FS: delimeter,
    });
    var sheet = workbook.Sheets[workbook.SheetNames[0]];
    var json;

    if (hasHeaders) {
      json = XLSX.utils.sheet_to_json(sheet);
    } else {
      json = XLSX.utils.sheet_to_json(sheet, {
        header: [...Array(1000).keys()].map((i) => `Column ${i}`),
      });
    }

    Logger.of("App.Core.FileUploader.convertText").info({
      json,
    });

    resolve(json);
  });
};
